import React from 'react';
import { Col } from 'react-bootstrap';
import { Row } from 'react-bootstrap';

const InsufficientPermission = () => (
  <div id="userDoesNotHaveRoleAssigned">
    <Row>
      <Col>
        Please note to edit this data you will need the adequate role assigned to you. If you do not
        have the proper credentials please contact a team Suzuka member.
      </Col>
    </Row>
    <Row>
      <Col>
        Please try a hard refresh first (Ctrl + F5) if you have been recently assigned a new role.
      </Col>
    </Row>
  </div>
);

export default InsufficientPermission;



// WEBPACK FOOTER //
// ./src/components/Dealers/InsufficientPermission.js